<template>
  <div ref="container" class="relative">
    <slot />
    <div ref="sticky" class="sticky-container">
      <slot name="sticky" />
    </div>
  </div>
</template>
<style lang="sass" scoped>
.sticky-container
  @apply absolute top-0
  left: 100%
  margin-left: 20px
</style>
<script>
export default {
  data() {
    return {
      tickid: null
    }
  },
  mounted() {
    this.tickid = requestAnimationFrame(this.tick);
  },
  beforeDestroy() {
    cancelAnimationFrame(this.tickid);
  },
  methods: {
    tick() {
      const { container, sticky } = this.$refs;
      const containerClientRect = container.getBoundingClientRect();
      const stickyClientRect = sticky.getBoundingClientRect();
      if (containerClientRect.bottom < stickyClientRect.height + 160) {
        sticky.style.position = 'absolute';
        sticky.style.top = containerClientRect.height - stickyClientRect.height + 'px';
        sticky.style.left = containerClientRect.width + 'px';
      } else if (containerClientRect.top < 160) {
        sticky.style.position = 'fixed';
        sticky.style.top = '160px';
        sticky.style.left = containerClientRect.right + 'px';
      } else {
        sticky.style.position = 'absolute';
        sticky.style.top = 0;
        sticky.style.left = containerClientRect.width + 'px';
      }
      this.tickid = requestAnimationFrame(this.tick);
    }
  }
}
</script>
